import { Location } from 'src/layouts/core-layout/components/CoreSearch/types'
import serialize from 'serialize-javascript'

export default function buildSearchUrl({ query, searchUrl, location }: {
  query: string
  searchUrl: string
  location?: Location
}) {
  const queryParams = location
    ? {
      q: query,
      [location.type]: location.name,
    }
    : {
      q: query,
    }

  return `${searchUrl}?${serialize(queryParams)}`
}
